function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M25.412 1.283A.5.5 0 0025 .5H1a.5.5 0 00-.412.783l9.246 13.472V25a.5.5 0 00.8.4l5.333-4a.5.5 0 00.2-.4v-6.245l9.245-13.472zM10.834 14.6a.5.5 0 00-.088-.283L1.95 1.5h22.1l-8.795 12.817a.5.5 0 00-.088.283v6.15L10.834 24v-9.4z",
  fill: "none",
  fillRule: "evenodd"
});

var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgFilter;